// extracted by mini-css-extract-plugin
module.exports = {"stars":"EuroFlag_stars__1RNcm","flagBg":"EuroFlag_flagBg__2reaE"};